<template>
  <material-card
    color="accent"
    height="100%"
    full-header
  >
    <template #heading>
      <div class="pa-8 white--text">
        <div class="text-h4 font-weight-light">
          {{ title }}
        </div>
        <div class="text-caption">
          {{ subtitle }}
        </div>
      </div>
    </template>
    <v-card-text>
      <v-data-table
        dense
        height="355px"
        :headers="headers"
        :items="contracts"
        :page.sync="page"
        hide-default-footer
        @page-count="pageCount = $event"
      >
        <template v-slot:item.contract_name="{ item }">
          <router-link
            v-if="(userHasPermission('view_logs'))"
            :to="`/contracts/${item.contract_id}`"
            class="text-decoration-none"
          >
            {{ item.contract_name }}
          </router-link>
          <span v-else>
            {{ item.contract_name }}
          </span>
        </template>
        <template v-slot:item.region_id="{ item }" v-if="regions.length > 0">
          {{ getRegion(item.region_id).region_short }}
        </template>
        <template v-slot:no-data>
          <div class="text-center pt-2">
            No contracts currently match this filter
          </div>
        </template>
      </v-data-table>
    </v-card-text>
    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="pageCount"
      />
    </div>
  </material-card>
</template>

<script>
  import { get } from 'vuex-pathify'
  export default {
    name: 'DashboardTableCard',
    props: {
      contracts: Array,
      title: String,
      subtitle: String,
    },
    data () {
      return {
        headers: [
          { value: 'contract_name', text: 'Customer' },
          { value: 'contract_number', text: 'Contract' },
          { value: 'region_id', text: 'Region', sortable: true },
        ],
        perPage: 10,
        page: 1,
        pageCount: 0,
      }
    },
    computed: {
      ...get('user', [
        'user',
      ]),
      ...get('settings', [
        'regions',
      ]),
    },
    methods: {
      userHasPermission: function (perm) {
        let perms = this.user.permissions.map(a => a.name)
        return perms.includes(perm)
      },
      getRegion: function (region_id) {
        let region = this.regions.find(element => element.region_id === region_id)
        return region
      }
    }
  }
</script>